import React from 'react'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

const SUCCESS_IMAGES = {
  'G00003660932': '/images/mega-coffee-americano-hot.jpeg',
  'G00001621744': '/images/mega-coffee-americano-ice.jpeg',
  'G00003421443': '/images/compose-coffee-americano-hot.jpeg',
  'G00003421395': '/images/compose-coffee-americano-ice.jpeg',
  'G00000750717': '/images/registSuccess5000.jpg',
}

const DEFAULT_IMAGE = '/images/registSuccess.png'

const ReviewSuccessPage = (props) => {
  const location = useLocation()
  const query = queryString.parse(location.search)
  const imageSrc = SUCCESS_IMAGES[query?.code] || DEFAULT_IMAGE
  const version = process.env.REACT_APP_VERSION

  return (
    <div>
      <div style={{ height: '100vh', backgroundColor: '#758aff' }}>
        <img
          src={`${imageSrc}?v=${version}`}
          alt="리뷰이벤트에 접수되었습니다."
          width="100%"
          style={{ marginTop: 30 }}
        />
      </div>
    </div>
  )
}

export default ReviewSuccessPage
